// src/components/PursuiteAccess/DedicatedRequestsTable.jsx
import React, { useState } from "react";
import {
    Box,
    Table,
    TableHeader,
    TableRow,
    TableCell,
    TableBody,
    Text,
    Button,
    Layer,
    Heading,
} from "grommet";
import { MailOption, FormView, View } from "grommet-icons";

// reuse the parseDelivery helper
export function parseDelivery(delivery) {
    if (Array.isArray(delivery)) return delivery;
    if (typeof delivery === "string") {
        try {
            const p = JSON.parse(delivery);
            if (Array.isArray(p)) return p;
        } catch { }
    }
    return [];
}

const DedicatedRequestsTable = ({ requests }) => {
    const [selected, setSelected] = useState(null);
    const [showLayer, setShowLayer] = useState(false);

    const openDetails = (r) => {
        setSelected(r);
        setShowLayer(true);
    };
    const closeDetails = () => {
        setShowLayer(false);
        setSelected(null);
    };

    // Opens a mailto: with subject/body template
    const sendEmail = (r) => {
        const email = r.learning_email;
        const subject = encodeURIComponent(
            `Your Dedicated Learning Request - HPE Digital Skill Advisor`
        );
        const body = encodeURIComponent(
            `Hello ${r.name},\n\n` +
            `Thank you for your dedicated learning request submitted on ${r.learning_date}.\n\n` +
            `Request details:\n` +
            `• Support Type: ${r.support_type}\n` +
            `• Delivery Method: ${parseDelivery(r.delivery_method).join(", ")}\n\n` +
            `We are reviewing your request and will get back shortly.\n\n` +
            `Regards,\n` +
            `Learning Team`
        );
        window.open(`mailto:${email}?subject=${subject}&body=${body}`);
    };

    return (
        <>
            <Box overflow="auto">
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableCell><Text weight="bold">#</Text></TableCell>
                            <TableCell><Text weight="bold">Date</Text></TableCell>
                            <TableCell><Text weight="bold">Name</Text></TableCell>
                            <TableCell><Text weight="bold">Email</Text></TableCell>
                            <TableCell><Text weight="bold">Country</Text></TableCell>
                            <TableCell><Text weight="bold">Support Needed</Text></TableCell>
                            <TableCell align="center"><Text weight="bold">Actions</Text></TableCell>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {requests.map((r, i) => (
                            <TableRow key={r.id}>
                                <TableCell><Text>{i + 1}</Text></TableCell>
                                <TableCell>
                                    <Text>
                                        {new Date(r.learning_date + "T00:00:00").toLocaleDateString("en-GB")}
                                    </Text>
                                </TableCell>
                                <TableCell><Text>{r.name}</Text></TableCell>
                                <TableCell><Text>{r.learning_email}</Text></TableCell>
                                <TableCell><Text>{r.learning_country}</Text></TableCell>
                                <TableCell><Text>{r.support_type}</Text></TableCell>
                                <TableCell align="center">
                                    <Box direction="row" gap="small" justify="center">
                                        <Button
                                            icon={<View />}
                                            tip="View Details"
                                            onClick={() => openDetails(r)}
                                            size="medium"
                                            color="brand"
                                        />
                                        <Button
                                            icon={<MailOption />}
                                            tip="Send Email"
                                            onClick={() => sendEmail(r)}
                                            size="medium"
                                            color="brand"
                                        />
                                    </Box>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Box>

            {/* ─── Details Modal ─── */}
            {showLayer && selected && (
                <Layer onEsc={closeDetails} onClickOutside={closeDetails}>
                    <Box pad="medium" width="large" gap="small">
                        <Heading level={3} margin="none">
                            Request Details
                        </Heading>
                        <Text><strong>Name:</strong> {selected.name}</Text>
                        <Text><strong>Email:</strong> {selected.learning_email}</Text>
                        <Text><strong>Phone:</strong> {selected.contact || "—"}</Text>
                        <Text><strong>Country:</strong> {selected.learning_country}</Text>
                        <Text><strong>Participants:</strong> {selected.num_participants || "—"}</Text>
                        <Text><strong>Support:</strong> {selected.support_type}</Text>
                        <Text>
                            <strong>Delivery:</strong>{" "}
                            {parseDelivery(selected.delivery_method).join(", ")}
                        </Text>
                        <Text>
                            <strong>Requested On:</strong>{" "}
                            {new Date(selected.learning_date + "T00:00:00").toLocaleDateString("en-GB")}{" "}
                            {selected.learning_time} ({selected.learning_timezone})
                        </Text>
                        <Text><strong>Message:</strong> {selected.message || "—"}</Text>

                        <Box align="end" margin={{ top: "medium" }}>
                            <Button label="Close" onClick={closeDetails} />
                        </Box>
                    </Box>
                </Layer>
            )}

        </>
    );
};

export default DedicatedRequestsTable;
